import React, { FC } from 'react'
import { Paper } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { TableToolbar } from 'src/components/ui'
import { formatTransferCountLabel } from 'src/components/columns/contractorTransferHelpers'

interface CountRow {
  id: string
  label: string
  count: number
}

const columns: GridColDef<CountRow>[] = [
  { field: 'label', headerName: 'Table or step', minWidth: 220, flex: 1, sortable: false },
  { field: 'count', headerName: 'Rows', type: 'number', minWidth: 120, sortable: false, align: 'left', headerAlign: 'left' }
]

interface ContractorTransferCountsProps {
  counts: Record<string, number>
  exportedFileName: string
}

/** The rows the transfer rewrote, per table and per job step. */
export const ContractorTransferCounts: FC<ContractorTransferCountsProps> = ({ counts, exportedFileName }) => {
  const rows: CountRow[] = Object.entries(counts)
    .map(([key, count]) => ({ id: key, label: formatTransferCountLabel(key), count }))
    .sort((left, right) => left.label.localeCompare(right.label))

  return (
    <Paper sx={{ width: '100%', minWidth: 0 }}>
      <DataGridPremium<CountRow>
        rows={rows}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        hideFooter
        slots={{ toolbar: () => <TableToolbar exportedFileName={exportedFileName} /> }}
        sx={{ border: 'none' }}
      />
    </Paper>
  )
}
